const translations = {
    en: {
        show_more: "Show more",
        category: "Category",
        search_word: "Search by Word",
        region: "Region",
        select: "Select...",
        price: "Price",
        over: "Over 2.5M",
        low: "Low to High",
        high: "High to Low",
        newest: "Newest To Oldest",
        oldest: "Oldest To Newest",
        city: "City",
        sort_by: "Sort by",
        search: "Search",
        more_filters: "More Filters",
        filters: "Filters",
        type: "Property Type",
        bedrooms: "Bedrooms",
        more: "More than 8",
        bathrooms: "Bathrooms",
        inside: "Inside Size",
        less_inside: "Less than 100",
        more_inside: "More than 500",
        plot: "Plot Size",
        less_plot: "Less than 500",
        more_plot: "More than 2500",
        location: "Location",
        sea_view: "Sea View",
        waterfront: "Waterfront",
        near_the_sea: "Near the Sea",
        beachfront: "Beachfront",
        mountain_view: "Mountain View",
        river_view: "River View",
        lake_view: "Lake View",
        near_town: "Near Town",
        village: "Village",
        facilities: "Facilities",
        year_built: "Year Built",
        clear: "Clear All",
        show: "Show Properties",
        heated_pool: "Heated Pool",
        outdoor_pool: "Outdoor Pool",
        indoor_pool: "Indoor Pool",
        boat_mooring: "Boat Mooring",
        garage: "Garage",
        hot_tub: "Hot Tub",
        vineyard: "Vineyard",
        gym: "Gym",
        sauna: "Sauna",
        wine_cellar: "Wine Cellar",
        tennis_court: "Tennis Court",
        game_room: "Game Room",
        garden: "Garden",
        terrace: "Terrace",
        balcony: "Balcony",
        outdoor_kitchen: "Outdoor Kitchen",
        elevator: "Elevator",
        popular_destinations: "Popular Destinations",
        popular: "Popular",
        price_range: "Price Range",
        min_price: "Min price",
        max_price: "Max price",
        min_size: "Min size",
        max_size: "Max size",

    },
    hr: {
        show_more: "Prikaži više",
        category: "Kategorija",
        search_word: "Pretraži po riječi",
        region: "Regija",
        select: "Odaberi...",
        price: "Cijena",
        over: "Više od 2.5M",
        low: "Od najniže do najviše",
        high: "Od najviše do najniže",
        newest: "Od najnovijeg do najstarijeg",
        oldest: "Od najstarijeg do najnovijeg",
        city: "Grad",
        sort_by: "Sortiraj po",
        search: "Pretraži",
        more_filters: "Više filtera",
        filters: "Filteri",
        type: "Tip nekretnine",
        bedrooms: "Spavaće sobe",
        more: "Više od 8",
        bathrooms: "Kupaonice",
        inside: "Unutarnja veličina",
        less_inside: "Manje od 100",
        more_inside: "Više od 500",
        plot: "Veličina parcele",
        less_plot: "Manje od 500",
        more_plot: "Više od 2500",
        location: "Lokacija",
        sea_view: "Pogled na more",
        waterfront: "Na obali",
        near_the_sea: "Blizu mora",
        beachfront: "Na plaži",
        mountain_view: "Pogled na planine",
        river_view: "Pogled na rijeku",
        lake_view: "Pogled na jezero",
        near_town: "Blizu grada",
        village: "Selo",
        facilities: "Sadržaji",
        year_built: "Godina izgradnje",
        clear: "Očisti sve",
        show: "Prikaži nekretnine",
        heated_pool: "Grijani bazen",
        outdoor_pool: "Vanjski bazen",
        indoor_pool: "Unutarnji bazen",
        boat_mooring: "Veza za brod",
        garage: "Garaža",
        hot_tub: "Vruća kada",
        vineyard: "Vinograd",
        gym: "Teretana",
        sauna: "Sauna",
        wine_cellar: "Vinska podrum",
        tennis_court: "Teniski teren",
        game_room: "Igraonica",
        garden: "Vrt",
        terrace: "Terasa",
        balcony: "Balkon",
        outdoor_kitchen: "Vanjska kuhinja",
        elevator: "Dizalo",
        popular_destinations: "Popularne destinacije",
        popular: "Popularno",
        price_range: "Raspon cijena",
        min_price: "Minimalna cijena",
        max_price: "Maksimalna cijena",
        min_size: "Minimalna veličina",
        max_size: "Maksimalna veličina"
    },
    de: {
        show_more: "Mehr anzeigen",
        category: "Kategorie",
        search_word: "Nach Wort suchen",
        region: "Region",
        select: "Auswählen...",
        price: "Preis",
        over: "Über 2.5M",
        low: "Von niedrig bis hoch",
        high: "Von hoch bis niedrig",
        newest: "Von neu nach alt",
        oldest: "Von alt nach neu",
        city: "Stadt",
        sort_by: "Sortieren nach",
        search: "Suchen",
        more_filters: "Mehr Filter",
        filters: "Filter",
        type: "Immobilientyp",
        bedrooms: "Schlafzimmer",
        more: "Mehr als 8",
        bathrooms: "Badezimmer",
        inside: "Innengröße",
        less_inside: "Weniger als 100",
        more_inside: "Mehr als 500",
        plot: "Grundstücksgröße",
        less_plot: "Weniger als 500",
        more_plot: "Mehr als 2500",
        location: "Standort",
        sea_view: "Meerblick",
        waterfront: "Am Wasser",
        near_the_sea: "In der Nähe des Meeres",
        beachfront: "Strandfront",
        mountain_view: "Bergblick",
        river_view: "Flussblick",
        lake_view: "Seeblick",
        near_town: "In der Nähe der Stadt",
        village: "Dorf",
        facilities: "Einrichtungen",
        year_built: "Baujahr",
        clear: "Alles löschen",
        show: "Immobilien anzeigen",
        heated_pool: "Beheizter Pool",
        outdoor_pool: "Außenpool",
        indoor_pool: "Innenpool",
        boat_mooring: "Bootsanleger",
        garage: "Garage",
        hot_tub: "Whirlpool",
        vineyard: "Weinberg",
        gym: "Fitnessstudio",
        sauna: "Sauna",
        wine_cellar: "Weinkeller",
        tennis_court: "Tennisplatz",
        game_room: "Spielzimmer",
        garden: "Garten",
        terrace: "Terrasse",
        balcony: "Balkon",
        outdoor_kitchen: "Außenküche",
        elevator: "Aufzug",
        popular_destinations: "Beliebte Reiseziele",
        popular: "Beliebt",
        price_range: "Preisspanne",
        min_price: "Mindestpreis",
        max_price: "Höchstpreis",
        min_size: "Mindestgröße",
        max_size: "Höchstgröße"
    },
    cs: {
        show_more: "Zobrazit více",
        category: "Kategorie",
        search_word: "Hledat podle slova",
        region: "Region",
        select: "Vybrat...",
        price: "Cena",
        over: "Přes 2.5M",
        low: "Od nejnižšího k nejvyššímu",
        high: "Od nejvyššího k nejnižšímu",
        newest: "Od nejnovějšího k nejstaršímu",
        oldest: "Od nejstaršího k nejnovějšímu",
        city: "Město",
        sort_by: "Seřadit podle",
        search: "Hledat",
        more_filters: "Více filtrů",
        filters: "Filtry",
        type: "Typ nemovitosti",
        bedrooms: "Ložnice",
        more: "Více než 8",
        bathrooms: "Koupelny",
        inside: "Velikost uvnitř",
        less_inside: "Méně než 100",
        more_inside: "Více než 500",
        plot: "Velikost pozemku",
        less_plot: "Méně než 500",
        more_plot: "Více než 2500",
        location: "Poloha",
        sea_view: "Výhled na moře",
        waterfront: "Na nábřeží",
        near_the_sea: "Blízko moře",
        beachfront: "Na pláži",
        mountain_view: "Výhled na hory",
        river_view: "Výhled na řeku",
        lake_view: "Výhled na jezero",
        near_town: "Blízko města",
        village: "Vesnice",
        facilities: "Zařízení",
        year_built: "Rok výstavby",
        clear: "Vymazat vše",
        show: "Zobrazit nemovitosti",
        heated_pool: "Vyhřívaný bazén",
        outdoor_pool: "Venkovní bazén",
        indoor_pool: "Krytý bazén",
        boat_mooring: "Přístav pro lodě",
        garage: "Garáž",
        hot_tub: "Vířivka",
        vineyard: "Vinice",
        gym: "Posilovna",
        sauna: "Sauna",
        wine_cellar: "Vinný sklep",
        tennis_court: "Tenisový kurt",
        game_room: "Herní místnost",
        garden: "Zahrada",
        terrace: "Terasa",
        balcony: "Balkon",
        outdoor_kitchen: "Venkovní kuchyně",
        elevator: "Výtah",
        popular_destinations: "Populární destinace",
        popular: "Oblíbený",
        price_range: "Cenové rozpětí",
        min_price: "Minimální cena",
        max_price: "Maximální cena",
        min_size: "Minimální velikost",
        max_size: "Maximální velikost"
    },
    es: {
        show_more: "Mostrar más",
        category: "Categoría",
        search_word: "Buscar por palabra",
        region: "Región",
        select: "Seleccionar...",
        price: "Precio",
        over: "Más de 2.5M",
        low: "De menor a mayor",
        high: "De mayor a menor",
        newest: "De más nuevo a más viejo",
        oldest: "De más viejo a más nuevo",
        city: "Ciudad",
        sort_by: "Ordenar por",
        search: "Buscar",
        more_filters: "Más filtros",
        filters: "Filtros",
        type: "Tipo de propiedad",
        bedrooms: "Dormitorios",
        more: "Más de 8",
        bathrooms: "Baños",
        inside: "Tamaño interior",
        less_inside: "Menos de 100",
        more_inside: "Más de 500",
        plot: "Tamaño del terreno",
        less_plot: "Menos de 500",
        more_plot: "Más de 2500",
        location: "Ubicación",
        sea_view: "Vista al mar",
        waterfront: "Frente al agua",
        near_the_sea: "Cerca del mar",
        beachfront: "Frente a la playa",
        mountain_view: "Vista a la montaña",
        river_view: "Vista al río",
        lake_view: "Vista al lago",
        near_town: "Cerca del pueblo",
        village: "Pueblo",
        facilities: "Instalaciones",
        year_built: "Año de construcción",
        clear: "Borrar todo",
        show: "Mostrar propiedades",
        heated_pool: "Piscina climatizada",
        outdoor_pool: "Piscina exterior",
        indoor_pool: "Piscina interior",
        boat_mooring: "Amarre para barcos",
        garage: "Garaje",
        hot_tub: "Jacuzzi",
        vineyard: "Viñedo",
        gym: "Gimnasio",
        sauna: "Sauna",
        wine_cellar: "Bodega",
        tennis_court: "Pista de tenis",
        game_room: "Sala de juegos",
        garden: "Jardín",
        terrace: "Terraza",
        balcony: "Balcón",
        outdoor_kitchen: "Cocina exterior",
        elevator: "Ascensor",
        popular_destinations: "Destinos populares",
        popular: "Popular",
        price_range: "Rango de precios",
        min_price: "Precio mínimo",
        max_price: "Precio máximo",
        min_size: "Tamaño mínimo",
        max_size: "Tamaño máximo"
    },
    fr: {
        "show_more": "Afficher plus",
        "category": "Catégorie",
        "search_word": "Rechercher par mot",
        "region": "Région",
        "select": "Sélectionner...",
        "price": "Prix",
        "over": "Plus de 2.5M",
        "low": "Du moins cher au plus cher",
        "high": "Du plus cher au moins cher",
        "newest": "Du plus récent au plus ancien",
        "oldest": "Du plus ancien au plus récent",
        "city": "Ville",
        "sort_by": "Trier par",
        "search": "Rechercher",
        "more_filters": "Plus de filtres",
        "filters": "Filtres",
        "type": "Type de propriété",
        "bedrooms": "Chambres",
        "more": "Plus de 8",
        "bathrooms": "Salles de bain",
        "inside": "Taille intérieure",
        "less_inside": "Moins de 100",
        "more_inside": "Plus de 500",
        "plot": "Taille du terrain",
        "less_plot": "Moins de 500",
        "more_plot": "Plus de 2500",
        "location": "Emplacement",
        "sea_view": "Vue sur mer",
        "waterfront": "Bord de l'eau",
        "near_the_sea": "Proche de la mer",
        "beachfront": "Front de mer",
        "mountain_view": "Vue sur montagne",
        "river_view": "Vue sur rivière",
        "lake_view": "Vue sur lac",
        "near_town": "Proche de la ville",
        "village": "Village",
        "facilities": "Installations",
        "year_built": "Année de construction",
        "clear": "Tout effacer",
        "show": "Afficher les propriétés",
        "heated_pool": "Piscine chauffée",
        "outdoor_pool": "Piscine extérieure",
        "indoor_pool": "Piscine intérieure",
        "boat_mooring": "Amarrage pour bateaux",
        "garage": "Garage",
        "hot_tub": "Jacuzzi",
        "vineyard": "Vignoble",
        "gym": "Salle de sport",
        "sauna": "Sauna",
        "wine_cellar": "Cave à vin",
        "tennis_court": "Court de tennis",
        "game_room": "Salle de jeux",
        "garden": "Jardin",
        "terrace": "Terrasse",
        "balcony": "Balcon",
        "outdoor_kitchen": "Cuisine extérieure",
        "elevator": "Ascenseur",
        "popular_destinations": "Destinations populaires",
        popular: "Populaire",
        price_range: "Fourchette de prix",
        min_price: "Prix minimum",
        max_price: "Prix maximum",
        min_size: "Taille minimale",
        max_size: "Taille maximale"
    },
    hu: {
        "show_more": "Többet mutat",
        "category": "Kategória",
        "search_word": "Keresés szó alapján",
        "region": "Régió",
        "select": "Válasszon...",
        "price": "Ár",
        "over": "2.5M felett",
        "low": "Növekvő sorrend",
        "high": "Csökkenő sorrend",
        "newest": "Legújabb elöl",
        "oldest": "Legrégebbi elöl",
        "city": "Város",
        "sort_by": "Rendezés",
        "search": "Keresés",
        "more_filters": "Több szűrő",
        "filters": "Szűrők",
        "type": "Ingatlan típusa",
        "bedrooms": "Hálószobák",
        "more": "Több mint 8",
        "bathrooms": "Fürdőszobák",
        "inside": "Belső méret",
        "less_inside": "Kevesebb mint 100",
        "more_inside": "Több mint 500",
        "plot": "Telek mérete",
        "less_plot": "Kevesebb mint 500",
        "more_plot": "Több mint 2500",
        "location": "Elhelyezkedés",
        "sea_view": "Tengerre néző",
        "waterfront": "Vízparti",
        "near_the_sea": "Tenger közelében",
        "beachfront": "Tengerparti",
        "mountain_view": "Hegyre néző",
        "river_view": "Folyóra néző",
        "lake_view": "Tóra néző",
        "near_town": "Város közelében",
        "village": "Falu",
        "facilities": "Létesítmények",
        "year_built": "Építés éve",
        "clear": "Összes törlése",
        "show": "Ingatlanok megjelenítése",
        "heated_pool": "Fűtött medence",
        "outdoor_pool": "Kültéri medence",
        "indoor_pool": "Beltéri medence",
        "boat_mooring": "Hajókikötő",
        "garage": "Garázs",
        "hot_tub": "Jacuzzi",
        "vineyard": "Szőlőültetvény",
        "gym": "Edzőterem",
        "sauna": "Szauna",
        "wine_cellar": "Borpince",
        "tennis_court": "Teniszpálya",
        "game_room": "Játékszoba",
        "garden": "Kert",
        "terrace": "Terasz",
        "balcony": "Erkély",
        "outdoor_kitchen": "Kültéri konyha",
        "elevator": "Lift",
        "popular_destinations": "Népszerű úti célok",
        popular: "Népszerű",
        price_range: "Ártartomány",
        min_price: "Minimális ár",
        max_price: "Maximális ár",
        min_size: "Minimális méret",
        max_size: "Maximális méret"
    },
    sl: {
        "show_more": "Pokaži več",
        "category": "Kategorija",
        "search_word": "Išči po besedi",
        "region": "Regija",
        "select": "Izberite...",
        "price": "Cena",
        "over": "Več kot 2.5M",
        "low": "Od najnižje do najvišje",
        "high": "Od najvišje do najnižje",
        "newest": "Od najnovejšega do najstarejšega",
        "oldest": "Od najstarejšega do najnovejšega",
        "city": "Mesto",
        "sort_by": "Razvrsti po",
        "search": "Išči",
        "more_filters": "Več filtrov",
        "filters": "Filtri",
        "type": "Vrsta nepremičnine",
        "bedrooms": "Spalnice",
        "more": "Več kot 8",
        "bathrooms": "Kopalnice",
        "inside": "Notranja velikost",
        "less_inside": "Manj kot 100",
        "more_inside": "Več kot 500",
        "plot": "Velikost zemljišča",
        "less_plot": "Manj kot 500",
        "more_plot": "Več kot 2500",
        "location": "Lokacija",
        "sea_view": "Pogled na morje",
        "waterfront": "Ob vodi",
        "near_the_sea": "Blizu morja",
        "beachfront": "Ob obali",
        "mountain_view": "Pogled na gore",
        "river_view": "Pogled na reko",
        "lake_view": "Pogled na jezero",
        "near_town": "Blizu mesta",
        "village": "Vas",
        "facilities": "Objekti",
        "year_built": "Leto izgradnje",
        "clear": "Počisti vse",
        "show": "Pokaži nepremičnine",
        "heated_pool": "Ogrevan bazen",
        "outdoor_pool": "Zunanji bazen",
        "indoor_pool": "Notranji bazen",
        "boat_mooring": "Privezišče za čolne",
        "garage": "Garaža",
        "hot_tub": "Jacuzzi",
        "vineyard": "Vinograd",
        "gym": "Fitnes",
        "sauna": "Savna",
        "wine_cellar": "Vinska klet",
        "tennis_court": "Tenis igrišče",
        "game_room": "Igralnica",
        "garden": "Vrt",
        "terrace": "Terasa",
        "balcony": "Balkon",
        "outdoor_kitchen": "Zunanja kuhinja",
        "elevator": "Dvigalo",
        "popular_destinations": "Priljubljene destinacije",
        popular: "Priljubljeno",
        price_range: "Cenovni razpon",
        min_price: "Najnižja cena",
        max_price: "Najvišja cena",
        min_size: "Najmanjša velikost",
        max_size: "Največja velikost"
    },
    pl: {
        "show_more": "Pokaż więcej",
        "category": "Kategoria",
        "search_word": "Szukaj według słowa",
        "region": "Region",
        "select": "Wybierz...",
        "price": "Cena",
        "over": "Ponad 2.5M",
        "low": "Od najmniejszej do największej",
        "high": "Od największej do najmniejszej",
        "newest": "Od najnowszych do najstarszych",
        "oldest": "Od najstarszych do najnowszych",
        "city": "Miasto",
        "sort_by": "Sortuj według",
        "search": "Szukaj",
        "more_filters": "Więcej filtrów",
        "filters": "Filtry",
        "type": "Rodzaj nieruchomości",
        "bedrooms": "Sypialnie",
        "more": "Więcej niż 8",
        "bathrooms": "Łazienki",
        "inside": "Wielkość wewnętrzna",
        "less_inside": "Mniej niż 100",
        "more_inside": "Więcej niż 500",
        "plot": "Wielkość działki",
        "less_plot": "Mniej niż 500",
        "more_plot": "Więcej niż 2500",
        "location": "Lokalizacja",
        "sea_view": "Widok na morze",
        "waterfront": "Przy wodzie",
        "near_the_sea": "Blisko morza",
        "beachfront": "Przy plaży",
        "mountain_view": "Widok na góry",
        "river_view": "Widok na rzekę",
        "lake_view": "Widok na jezioro",
        "near_town": "Blisko miasta",
        "village": "Wieś",
        "facilities": "Udogodnienia",
        "year_built": "Rok budowy",
        "clear": "Wyczyść wszystko",
        "show": "Pokaż nieruchomości",
        "heated_pool": "Podgrzewany basen",
        "outdoor_pool": "Basen zewnętrzny",
        "indoor_pool": "Basen kryty",
        "boat_mooring": "Przystań dla łodzi",
        "garage": "Garaż",
        "hot_tub": "Jacuzzi",
        "vineyard": "Winnica",
        "gym": "Siłownia",
        "sauna": "Sauna",
        "wine_cellar": "Piwnica na wino",
        "tennis_court": "Kort tenisowy",
        "game_room": "Pokój gier",
        "garden": "Ogród",
        "terrace": "Taras",
        "balcony": "Balkon",
        "outdoor_kitchen": "Kuchnia zewnętrzna",
        "elevator": "Winda",
        "popular_destinations": "Popularne miejsca",
        popular: "Popularny",
        price_range: "Przedział cenowy",
        min_price: "Cena minimalna",
        max_price: "Cena maksymalna",
        min_size: "Minimalny rozmiar",
        max_size: "Maksymalny rozmiar"
    },
    fi: {
        show_more: "Näytä lisää",
        category: "Kategoria",
        search_word: "Etsi sanalla",
        region: "Alue",
        select: "Valitse...",
        price: "Hinta",
        over: "Yli 2,5M",
        low: "Alin ensin",
        high: "Korkein ensin",
        newest: "Uusin ensin",
        oldest: "Vanhin ensin",
        city: "Kaupunki",
        sort_by: "Lajittele",
        search: "Etsi",
        more_filters: "Lisää suodattimia",
        filters: "Suodattimet",
        type: "Kiinteistön tyyppi",
        bedrooms: "Makuuhuoneet",
        more: "Yli 8",
        bathrooms: "Kylpyhuoneet",
        inside: "Sisäpinta-ala",
        less_inside: "Alle 100",
        more_inside: "Yli 500",
        plot: "Tontin koko",
        less_plot: "Alle 500",
        more_plot: "Yli 2500",
        location: "Sijainti",
        sea_view: "Merinäköala",
        waterfront: "Rantaviiva",
        near_the_sea: "Lähellä merta",
        beachfront: "Rantaviiva",
        mountain_view: "Vuoristonäkymä",
        river_view: "Jokinäkymä",
        lake_view: "Järvinäkymä",
        near_town: "Lähellä kaupunkia",
        village: "Kylä",
        facilities: "Mukavuudet",
        year_built: "Rakennusvuosi",
        clear: "Tyhjennä kaikki",
        show: "Näytä kiinteistöt",
        heated_pool: "Lämmitetty uima-allas",
        outdoor_pool: "Ulkouima-allas",
        indoor_pool: "Sisäuima-allas",
        boat_mooring: "Veneen kiinnityspaikka",
        garage: "Autotalli",
        hot_tub: "Poreallas",
        vineyard: "Viinitarha",
        gym: "Kuntosali",
        sauna: "Sauna",
        wine_cellar: "Viinikellari",
        tennis_court: "Tenniskenttä",
        game_room: "Peliaula",
        garden: "Puutarha",
        terrace: "Terassi",
        balcony: "Parveke",
        outdoor_kitchen: "Ulkokeittiö",
        elevator: "Hissi",
        popular_destinations: "Suositut kohteet",
        popular: "Suosittu",
        price_range: "Hintahaarukka",
        min_price: "Minimihinta",
        max_price: "Maksimihinta",
        min_size: "Pienin koko",
        max_size: "Suurin koko"
    },
    no: {
        show_more: "Vis mer",
        category: "Kategori",
        search_word: "Søk etter ord",
        region: "Region",
        select: "Velg...",
        price: "Pris",
        over: "Over 2,5M",
        low: "Lav til høy",
        high: "Høy til lav",
        newest: "Nyeste til eldste",
        oldest: "Eldste til nyeste",
        city: "By",
        sort_by: "Sorter etter",
        search: "Søk",
        more_filters: "Flere filtre",
        filters: "Filtre",
        type: "Eiendomstype",
        bedrooms: "Soverom",
        more: "Mer enn 8",
        bathrooms: "Bad",
        inside: "Innvendig størrelse",
        less_inside: "Mindre enn 100",
        more_inside: "Mer enn 500",
        plot: "Tomtestørrelse",
        less_plot: "Mindre enn 500",
        more_plot: "Mer enn 2500",
        location: "Beliggenhet",
        sea_view: "Sjøutsikt",
        waterfront: "Vannkanten",
        near_the_sea: "Nær sjøen",
        beachfront: "Strandlinje",
        mountain_view: "Fjellutsikt",
        river_view: "Elveutsikt",
        lake_view: "Innsjøutsikt",
        near_town: "Nær byen",
        village: "Landsby",
        facilities: "Fasiliteter",
        year_built: "Byggeår",
        clear: "Tøm alle",
        show: "Vis eiendommer",
        heated_pool: "Oppvarmet basseng",
        outdoor_pool: "Utendørs basseng",
        indoor_pool: "Innendørs basseng",
        boat_mooring: "Båtplass",
        garage: "Garasje",
        hot_tub: "Boblebad",
        vineyard: "Vingård",
        gym: "Treningsrom",
        sauna: "Badstue",
        wine_cellar: "Vinkjeller",
        tennis_court: "Tennisbane",
        game_room: "Spillerom",
        garden: "Hage",
        terrace: "Terrasse",
        balcony: "Balkong",
        outdoor_kitchen: "Utekjøkken",
        elevator: "Heis",
        popular_destinations: "Populære destinasjoner",
        popular: "Populær",
        price_range: "Prisspenn",
        min_price: "Minste pris",
        max_price: "Maksimal pris",
        min_size: "Minste størrelse",
        max_size: "Største størrelse"
    },
    sv: {
        show_more: "Visa mer",
        category: "Kategori",
        search_word: "Sök efter ord",
        region: "Region",
        select: "Välj...",
        price: "Pris",
        over: "Över 2,5M",
        low: "Lågt till högt",
        high: "Högt till lågt",
        newest: "Nyast till äldst",
        oldest: "Äldst till nyast",
        city: "Stad",
        sort_by: "Sortera efter",
        search: "Sök",
        more_filters: "Fler filter",
        filters: "Filter",
        type: "Fastighetstyp",
        bedrooms: "Sovrum",
        more: "Mer än 8",
        bathrooms: "Badrum",
        inside: "Innervåning",
        less_inside: "Mindre än 100",
        more_inside: "Mer än 500",
        plot: "Tomtstorlek",
        less_plot: "Mindre än 500",
        more_plot: "Mer än 2500",
        location: "Plats",
        sea_view: "Havsutsikt",
        waterfront: "Vid vattnet",
        near_the_sea: "Nära havet",
        beachfront: "Strandlinje",
        mountain_view: "Bergsutsikt",
        river_view: "Flodutsikt",
        lake_view: "Sjööversikt",
        near_town: "Nära stan",
        village: "By",
        facilities: "Faciliteter",
        year_built: "Byggnadsår",
        clear: "Rensa alla",
        show: "Visa fastigheter",
        heated_pool: "Uppvärmd pool",
        outdoor_pool: "Utomhuspool",
        indoor_pool: "Inomhuspool",
        boat_mooring: "Båtplats",
        garage: "Garage",
        hot_tub: "Bubbelpool",
        vineyard: "Vingård",
        gym: "Gym",
        sauna: "Bastu",
        wine_cellar: "Vinkällare",
        tennis_court: "Tennisbana",
        game_room: "Spelrum",
        garden: "Trädgård",
        terrace: "Terrass",
        balcony: "Balkong",
        outdoor_kitchen: "Utekök",
        elevator: "Hiss",
        popular_destinations: "Populära destinationer",
        popular: "Populär",
        price_range: "Prisklass",
        min_price: "Lägsta pris",
        max_price: "Högsta pris",
        min_size: "Minsta storlek",
        max_size: "Största storlek"
    },
    it: {
        show_more: "Mostra di più",
        category: "Categoria",
        search_word: "Cerca per Parola",
        region: "Regione",
        select: "Seleziona...",
        price: "Prezzo",
        over: "Oltre 2.5M",
        low: "Dal Basso all'Alto",
        high: "Dall'Alto al Basso",
        newest: "Dal Più Recente al Più Vecchio",
        oldest: "Dal Più Vecchio al Più Recente",
        city: "Città",
        sort_by: "Ordina per",
        search: "Cerca",
        more_filters: "Altri Filtri",
        filters: "Filtri",
        type: "Tipo di Proprietà",
        bedrooms: "Camere da Letto",
        more: "Più di 8",
        bathrooms: "Bagni",
        inside: "Dimensione Interna",
        less_inside: "Meno di 100",
        more_inside: "Più di 500",
        plot: "Dimensione del Terreno",
        less_plot: "Meno di 500",
        more_plot: "Più di 2500",
        location: "Posizione",
        sea_view: "Vista Mare",
        waterfront: "Fronte Mare",
        near_the_sea: "Vicino al Mare",
        beachfront: "Fronte Spiaggia",
        mountain_view: "Vista Montagna",
        river_view: "Vista Fiume",
        lake_view: "Vista Lago",
        near_town: "Vicino alla Città",
        village: "Villaggio",
        facilities: "Servizi",
        year_built: "Anno di Costruzione",
        clear: "Cancella Tutto",
        show: "Mostra Proprietà",
        heated_pool: "Piscina Riscaldata",
        outdoor_pool: "Piscina All'Aperto",
        indoor_pool: "Piscina Coperta",
        boat_mooring: "Ormeggio",
        garage: "Garage",
        hot_tub: "Vasca Idromassaggio",
        vineyard: "Vigneto",
        gym: "Palestra",
        sauna: "Sauna",
        wine_cellar: "Cantina",
        tennis_court: "Campo da Tennis",
        game_room: "Sala Giochi",
        garden: "Giardino",
        terrace: "Terrazza",
        balcony: "Balcone",
        outdoor_kitchen: "Cucina All'Aperto",
        elevator: "Ascensore",
        popular_destinations: "Destinazioni Popolari",
        popular: "Popolare",
        price_range: "Fascia di prezzo",
        min_price: "Prezzo minimo",
        max_price: "Prezzo massimo",
        min_size: "Dimensione minima",
        max_size: "Dimensione massima"
    },
    uk: {
        show_more: "Показати більше",
        category: "Категорія",
        search_word: "Пошук за словом",
        region: "Регіон",
        select: "Виберіть...",
        price: "Ціна",
        over: "Більше 2.5M",
        low: "Від нижчого до вищого",
        high: "Від вищого до нижчого",
        newest: "Від найновіших до найстаріших",
        oldest: "Від найстаріших до найновіших",
        city: "Місто",
        sort_by: "Сортувати за",
        search: "Пошук",
        more_filters: "Більше фільтрів",
        filters: "Фільтри",
        type: "Тип нерухомості",
        bedrooms: "Спальні",
        more: "Більше 8",
        bathrooms: "Ванні кімнати",
        inside: "Розмір приміщення",
        less_inside: "Менше 100",
        more_inside: "Більше 500",
        plot: "Розмір ділянки",
        less_plot: "Менше 500",
        more_plot: "Більше 2500",
        location: "Розташування",
        sea_view: "Вид на море",
        waterfront: "На березі води",
        near_the_sea: "Біля моря",
        beachfront: "На березі",
        mountain_view: "Вид на гори",
        river_view: "Вид на річку",
        lake_view: "Вид на озеро",
        near_town: "Біля міста",
        village: "Село",
        facilities: "Зручності",
        year_built: "Рік побудови",
        clear: "Очистити все",
        show: "Показати нерухомість",
        heated_pool: "Підігрітий басейн",
        outdoor_pool: "Відкритий басейн",
        indoor_pool: "Критий басейн",
        boat_mooring: "Причал для човнів",
        garage: "Гараж",
        hot_tub: "Гаряча ванна",
        vineyard: "Виноградник",
        gym: "Тренажерний зал",
        sauna: "Сауна",
        wine_cellar: "Винний підвал",
        tennis_court: "Тенісний корт",
        game_room: "Ігрова кімната",
        garden: "Сад",
        terrace: "Тераса",
        balcony: "Балкон",
        outdoor_kitchen: "Кухня на відкритому повітрі",
        elevator: "Ліфт",
        popular_destinations: "Популярні місця",
        popular: "Популярний",
        price_range: "Ціновий діапазон",
        min_price: "Мінімальна ціна",
        max_price: "Максимальна ціна",
        min_size: "Мінімальний розмір",
        max_size: "Максимальний розмір"
    },
    sk: {
        show_more: "Ukázať viac",
        category: "Kategória",
        search_word: "Hľadať podľa slova",
        region: "Región",
        select: "Vyberte...",
        price: "Cena",
        over: "Nad 2.5M",
        low: "Od najnižšej po najvyššiu",
        high: "Od najvyššej po najnižšiu",
        newest: "Od najnovších po najstaršie",
        oldest: "Od najstarších po najnovšie",
        city: "Mesto",
        sort_by: "Triediť podľa",
        search: "Vyhľadávanie",
        more_filters: "Viac filtrov",
        filters: "Filtre",
        type: "Typ nehnuteľnosti",
        bedrooms: "Spálne",
        more: "Viac ako 8",
        bathrooms: "Kúpeľne",
        inside: "Veľkosť vnútri",
        less_inside: "Menej ako 100",
        more_inside: "Viac ako 500",
        plot: "Veľkosť pozemku",
        less_plot: "Menej ako 500",
        more_plot: "Viac ako 2500",
        location: "Poloha",
        sea_view: "Výhľad na more",
        waterfront: "Na nábreží",
        near_the_sea: "Blízko mora",
        beachfront: "Na pláži",
        mountain_view: "Výhľad na hory",
        river_view: "Výhľad na rieku",
        lake_view: "Výhľad na jazero",
        near_town: "Blízko mesta",
        village: "Dedina",
        facilities: "Vybavenie",
        year_built: "Rok výstavby",
        clear: "Vyčistiť všetko",
        show: "Zobraziť nehnuteľnosti",
        heated_pool: "Vyhrievaný bazén",
        outdoor_pool: "Vonkajší bazén",
        indoor_pool: "Vnútorný bazén",
        boat_mooring: "Prístavisko pre člny",
        garage: "Garáž",
        hot_tub: "Horúca vaňa",
        vineyard: "Vinica",
        gym: "Posilňovňa",
        sauna: "Sauna",
        wine_cellar: "Vínna pivnica",
        tennis_court: "Tenisový kurt",
        game_room: "Herná miestnosť",
        garden: "Záhrada",
        terrace: "Terasa",
        balcony: "Balkón",
        outdoor_kitchen: "Vonkajšia kuchyňa",
        elevator: "Výťah",
        popular_destinations: "Populárne destinácie",
        popular: "Populárny",
        price_range: "Cenové rozpätie",
        min_price: "Minimálna cena",
        max_price: "Maximálna cena",
        min_size: "Minimálna veľkosť",
        max_size: "Maximálna veľkosť"
    },
    nl: {
        show_more: "Meer weergeven",
        category: "Categorie",
        search_word: "Zoeken op woord",
        region: "Regio",
        select: "Selecteer...",
        price: "Prijs",
        over: "Meer dan 2.5M",
        low: "Laag naar hoog",
        high: "Hoog naar laag",
        newest: "Nieuwste naar oudste",
        oldest: "Oudste naar nieuwste",
        city: "Stad",
        sort_by: "Sorteren op",
        search: "Zoeken",
        more_filters: "Meer filters",
        filters: "Filters",
        type: "Type eigendom",
        bedrooms: "Slaapkamers",
        more: "Meer dan 8",
        bathrooms: "Badkamers",
        inside: "Binnenmaat",
        less_inside: "Minder dan 100",
        more_inside: "Meer dan 500",
        plot: "Perceelgrootte",
        less_plot: "Minder dan 500",
        more_plot: "Meer dan 2500",
        location: "Locatie",
        sea_view: "Zeezicht",
        waterfront: "Aan het water",
        near_the_sea: "Dicht bij de zee",
        beachfront: "Aan het strand",
        mountain_view: "Uitzicht op de bergen",
        river_view: "Uitzicht op de rivier",
        lake_view: "Uitzicht op het meer",
        near_town: "Dicht bij de stad",
        village: "Dorp",
        facilities: "Voorzieningen",
        year_built: "Bouwjaar",
        clear: "Alles wissen",
        show: "Toon eigendommen",
        heated_pool: "Verwarmd zwembad",
        outdoor_pool: "Buitenzwembad",
        indoor_pool: "Binnenzwembad",
        boat_mooring: "Bootaanlegplaats",
        garage: "Garage",
        hot_tub: "Hottub",
        vineyard: "Wijngaard",
        gym: "Sportschool",
        sauna: "Sauna",
        wine_cellar: "Wijnkelder",
        tennis_court: "Tennisbaan",
        game_room: "Spelkamer",
        garden: "Tuin",
        terrace: "Terras",
        balcony: "Balkon",
        outdoor_kitchen: "Buitenkeuken",
        elevator: "Lift",
        popular_destinations: "Populaire bestemmingen",
        popular: "Populair",
        price_range: "Prijsklasse",
        min_price: "Minimale prijs",
        max_price: "Maximale prijs",
        min_size: "Minimale grootte",
        max_size: "Maximale grootte"
    }
}
export function getTranslation(langCode) {
    return translations[langCode];
}